import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "playlistId", "showNotification", "showTooltip", "onClick", "use", "onSuccess", "textAlign", "render"];
import I18n from 'I18n';
import Raven from 'raven-js';
import { useMemo } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { usePlaylistArchivedStatus } from '../myPlaylistsHooks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { ArchivePlaylistNotification, UnarchivePlaylistNotification } from '../../savedItems/components/PlaylistNotifications';
import { jsx as _jsx } from "react/jsx-runtime";
export const ArchivePlaylistsToggleIconMessage = ({
  isArchived
}) => isArchived ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "academyCommon.savedItems.tooltips.unsavedHoverOwner"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "academyCommon.savedItems.tooltips.savedHoverOwner"
});
export const ArchivePlaylistButton = _ref => {
  let {
      children,
      playlistId,
      showNotification = true,
      showTooltip = false,
      onClick,
      use = 'unstyled',
      onSuccess,
      textAlign = 'start',
      render
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isArchived,
    isLoading,
    togglePlaylistArchivedStatus
  } = usePlaylistArchivedStatus(playlistId);
  const performArchiveAction = () => {
    if (isLoading) return;
    const trackingAction = isArchived ? 'unarchive-playlist' : 'archive-playlist';
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: trackingAction,
      playlistId
    });
    togglePlaylistArchivedStatus().then(() => {
      if (showNotification) {
        if (isArchived) {
          FloatingAlertStore.addAlert({
            message: /*#__PURE__*/_jsx(UnarchivePlaylistNotification, {
              playlistId: playlistId
            }),
            type: 'success'
          });
        } else {
          FloatingAlertStore.addAlert({
            message: /*#__PURE__*/_jsx(ArchivePlaylistNotification, {
              playlistId: playlistId
            }),
            type: 'success'
          });
        }
      }
      onSuccess === null || onSuccess === void 0 || onSuccess();
    }).catch(() => {
      Raven.captureMessage(`Achievements: error archiving playlist`, {
        extra: {
          playlistId,
          isArchived
        }
      });
    });
  };
  const handleButtonClick = e => {
    if (onClick) onClick(e);
    performArchiveAction();
  };
  const tooltip = useMemo(() => {
    if (!showTooltip) return null;
    return I18n.text('academyCommon.savedItems.tooltips.archiveHover');
  }, [showTooltip]);
  if (render) {
    return render({
      onClick: performArchiveAction,
      isArchived: isArchived || null,
      isLoading
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "right",
    title: tooltip,
    children: /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
      disabled: isLoading,
      onClick: handleButtonClick,
      use: use,
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        textAlign: textAlign,
        children: children || /*#__PURE__*/_jsx(ArchivePlaylistsToggleIconMessage, {
          isArchived: isArchived || null
        })
      })
    }))
  });
};
export default ArchivePlaylistButton;